import PropTypes from 'prop-types';
import { cloneElement } from 'react';
import { omit } from 'ramda';
import MaskedInput from 'react-maskedinput';
import { similarsToCyrillics, similarsToLatins, similarsToRomans, CAPITAL_SIMILAR_CYRILLICS_STR, CAPITAL_SIMILAR_LATINS_STR, CAPITAL_ROMANS_STR, CAPITAL_SIMILAR_ROMANS_STR } from '../../../constants/similar-chars';
import FieldWrapper from './FieldWrapper';
import AutocompleteToggle from './AutocompleteToggle';
import TouchEvents from '../TouchEvents';
const customFormatCharacters = {
  R: {
    validate: char => new RegExp(`[${CAPITAL_ROMANS_STR}${CAPITAL_SIMILAR_ROMANS_STR}]`, 'i').test(char),
    transform: char => similarsToRomans(char).toUpperCase()
  },
  Ъ: {
    validate: char => new RegExp(`[а-я${CAPITAL_SIMILAR_CYRILLICS_STR}]`, 'i').test(char),
    transform: char => similarsToCyrillics(char).toUpperCase()
  },
  U: {
    validate: char => new RegExp(`[a-z${CAPITAL_SIMILAR_LATINS_STR}]`, 'i').test(char),
    transform: char => similarsToLatins(char).toUpperCase()
  }
};
const TextInput = props => {
  const {
    id,
    isValid = true,
    value = '',
    placeholder = '',
    onChange,
    isDisabled = false,
    isAutocompleteAllowed = false,
    mask,
    size = 255,
    formatCharacters = {},
    onBlur,
    className,
    errors,
    name,
    ...otherProps
  } = props;
  let input;
  if (mask !== undefined) {
    input = /*#__PURE__*/React.createElement(MaskedInput, {
      mask: mask,
      size: size,
      formatCharacters: {
        ...formatCharacters,
        ...customFormatCharacters
      }
    });
  } else {
    input = /*#__PURE__*/React.createElement("input", null);
  }
  input = /*#__PURE__*/React.createElement(AutocompleteToggle, {
    isAutocompleteAllowed: isAutocompleteAllowed
  }, /*#__PURE__*/cloneElement(input, {
    id,
    type: 'text',
    className: 'form-control',
    value,
    placeholder,
    disabled: isDisabled,
    onChange: e => onChange && onChange(e.target.value, name, e),
    onBlur: e => onBlur && onBlur(e.target.value, name, e),
    ref: otherProps.innerRef,
    // TODO: заплатка понадобилась по причине того, чтото ктото начал передавать в field пропс 'onTap' с целью
    // его использования в обертке. С оберткой все ок, а вот пропс не подчищается в field. Пришлось это сделать тут
    ...omit(['onTap', 'renderFieldWrapper', 'fieldWrapperProps', 'isOnlyField', 'isForceShownError', 'isMobileFieldWrapper', 'isNative', 'isFormattedValue', 'onClickIcon', 'isPassengerListDisabled', 'iconClassName', 'labelName', 'innerRef'], otherProps)
  }));
  return /*#__PURE__*/React.createElement(FieldWrapper, {
    ...props,
    errors: errors,
    className: className,
    isValid: isValid
  }, /*#__PURE__*/React.createElement(TouchEvents, null, input));
};
TextInput.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  isValid: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isAutocompleteAllowed: PropTypes.bool,
  mask: PropTypes.string,
  value: PropTypes.string,
  size: PropTypes.number,
  formatCharacters: PropTypes.object,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  errors: PropTypes.any,
  onBlur: PropTypes.func,
  name: PropTypes.node
};
export default TextInput;